﻿export const setTypeaheadOptions = ({ targetId, baseApi }) => ({
	input: `#${targetId}`,
	minLength: 2,
	maxItemPerGroup: 5,
	dynamic: true,
	emptyTemplate: (query) => _emptyTemplate(query),
	group: {
		key: 'ProductTypeCode',
		template: item => _getProductTypeDisplayValue(item.ProductTypeCode),
	},
	source: {
		products: {
			display: ['DisplayName', 'TickerSymbol', 'TickerSymbol'],
			template: '{{DisplayName}} - <em>{{TickerSymbol}}</em>',
			href: item => _getProductTargetUrl(item),
			ajax: {
				method: 'GET',
				url: `${baseApi}/api/ProductSearch/UnitedStates/Retail/US/{{query}}`,
			},
		},
	},
});

const _getProductTypeDisplayValue = productTypeCode => {
	switch (productTypeCode) {
		case 'ETF':
			return 'Exchange-Traded Funds';

		case 'CEF':
			return 'Closed-End Funds';

		case 'MF':
			return 'Mutual Funds';

		case 'UIT':
			return 'Unit Investment Trusts';

		default:
			return '';
	}
}

const _getProductTargetUrl = ({ ProductTypeCode, TickerSymbol, ProductCode }) => {
	switch (ProductTypeCode) {
		case 'ETF':
			return `/etfs/${TickerSymbol}`;

		case 'CEF':
			return `/cefs/${TickerSymbol}`;

		case 'MF':
			return `/mfs/${TickerSymbol}`;

		case 'UIT':
			return `/uits/${ProductCode}`;

		default:
			return '/';
	}
}

const _emptyTemplate = (query) => (`No results found for <strong>${query}</strong>`);

